export const TappableAreaHeight = 12;

export const TappableAreaHeightLarge = 24;
